export default __webpack_public_path__ + "static/media/slider_1.04bff05a.png";